const formatMoneyValue = (value: number, currency = 'USD', fixedPoint = false): string => {
  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency })
  const formatted = formatter.format(value / 100)
  return (!fixedPoint) ? formatted.replace(/[,.]00$/i, '') : formatted
}

export default formatMoneyValue
